import * as api from "./api";

export async function getChatOverview(options, queryParams) {
	try {
		const res = await api.get("/backend/chat/overview/teacher", options, queryParams, () => {});
		return res;
	} catch (err) {
		throw err;
	}
}

export async function getClassChatOverview(options, queryParams) {
	const res = await api.get("/backend/chat/overview/classroom", options, queryParams, () => {});
	return res;
}

export async function getMessages(options, queryParams) {
	const res = await api.get("/backend/chat", options, queryParams, () => {});
	return res;
}

export async function sendMessage(message, options) {
	try {
		const res = await api.post("/backend/chat", message, options);
		return res;
	} catch (err) {
		throw err;
	}
}

export async function getDisplayName(options, params) {
	try {
		const res = await api.get("/backend/chat/displayname", options, params, () => {});
		return res;
	} catch (err) {
		throw err;
	}
}

export async function saveDisplayName(displayNameData, options) {
	try {
		const res = await api.put("/backend/chat/displayname", displayNameData, options);

		return res;
	} catch (err) {
		throw err;
	}
}

export async function markThreadAsRead(body, options) {
	try {
		const res = await api.post("/backend/chat/thread/markasread", body, options);
		return res;
	} catch (err) {
		throw err;
	}
}

export async function markClassroomThreadsAsRead(body, options) {
	try {
		const res = await api.post("/backend/chat/thread/markasread/classroom", body, options);
		return res;
	} catch (err) {
		throw err;
	}
}
